<template>
	<div>
		<div ref="publish-container" />
		<div ref="client-container" />
	</div>
</template>

<script>
export default {
	inject: {
		openTokSessionReady: { type: Boolean },
		publishVideoStream: { type: Function },
		openTokClientStreamReady: { type: Boolean },
		subscribeClientStream: { type: Function },
		changeSubscribeTasksCount: { type: Function }
	},
	watch: {
		'openTokSessionReady.value': {
			handler() {
				this.publish();
			},
			flush: `post`,
			immediate: true
		},
		'openTokClientStreamReady.value': {
			handler() {
				this.subscribe();
			},
			flush: `post`,
			immediate: true
		}
	},
	beforeMount() {
		this.changeSubscribeTasksCount();
	},
	unmounted() {
		this.changeSubscribeTasksCount(-1);
	},
	methods: {
		publish() {
			if (this.openTokSessionReady.value) {
				const publishElement = this.$refs[`publish-container`];
				this.publishVideoStream(publishElement);
			}
		},
		subscribe() {
			if (this.openTokClientStreamReady.value) {
				const subscribeElement = this.$refs[`client-container`];
				this.subscribeClientStream(subscribeElement, true);
			}
		}
	},
};
</script>